// src/pages/EditRadiologistStatus.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth'; // custom hook
import '../styles/EmployeeMaster.css';

const EditManagerRadiologistStatus = () => {
  const { id } = useParams();
  const { authFetch } = useAuth('/login');
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [status, setStatus] = useState('');
  const [candidateName, setCandidateName] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  // ✅ Fetch candidate info
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await authFetch(`${baseUrl}/getCandidateFullDetails/${id}`);
        const data = await res.json();
        if (data?.candidate) {
          setCandidateName(data.candidate.candidate_name);
          setStatus(data.candidate.rpt_mgr_status || 'Pending');
        } else {
          setError('Candidate not found.');
        }
      } catch (err) {
        setError('Error fetching candidate data');
      }
    };
    fetchDetails();
  }, [authFetch, baseUrl, id]);
const user_code = sessionStorage.getItem('user_code');
 const user_name = sessionStorage.getItem('user_name');
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      const res = await authFetch(`${baseUrl}/updateHrStatusId/${id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ hr_status: status,hr: user_code, hr_name: user_name }),
      });

      const result = await res.json();
      if (result.status) {
        alert('Status updated successfully!');
        navigate('/hr-radiology-assessment'); // 🔁 back to list
      } else {
        setError(result.message || 'Failed to update status');
      }
    } catch (err) {
      setError('Submission error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container mt-4">
      <h3>Update Status for: {candidateName}</h3>
      <form onSubmit={handleSubmit} className="mt-3">
        <div className="form-group mb-3">
          <label className="form-label">Hr Status</label>
          <select
            className="form-select"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            disabled={saving}
          >
            <option value="Pending">Pending</option>
            <option value="Approved">Approved</option>
            <option value="Rejected">Rejected</option>
          </select>
        </div>

        {error && <div className="text-danger mb-2">{error}</div>}

        <button type="submit" className="btn btn-primary" disabled={saving}>
          {saving ? 'Saving...' : 'Update Status'}
        </button>
      </form>
    </div>
  );
};

export default EditManagerRadiologistStatus;
